<template>
  <div id="lodging-show-phone">
    <div
      id="experiences-lodging"
      class="experiences-lodging"
      data-aos="fade-up"
      data-aos-duration="900"
    >
      <div class="container-lodging phone">

        <!-- <slither-slider :options="{ numberOfSlides: 2, dots: false, controls: false }"> -->
       <div class="lodging-category-container">
          <h1
            v-for="category in categories"
            :key="category"
            class="lodging-category"
            :class="{ active: SelectedOption === category }"
            @click="SelectedOption = category"
          >
            <p class="raleway-reg-p16" :data-value="category">{{ category }}</p>
          </h1>
        </div>

        <!-- </slither-slider> -->

        <template v-if="this.experiencesFiltered.length">
          <!-- <slither-slider :options="{ numberOfSlides: 1, dots: false, controls: false }"> -->
          <div class="card-lodging-container">
            <div v-for="(experience, index) in this.experiencesFiltered" :key="index">
              <Cardexplodging :experience="experience" :user="isUserConnected()" :hideDescription="true" @open-modal="openModal" @connection="$emit('connection')"></Cardexplodging>
            </div>
          </div>

          <!-- </slither-slider> -->
        </template>
        <template v-else>
          <!-- <slither-slider :options="{ numberOfSlides: 1, dots: false, controls: false }">
            <div> -->
          <p class="raleway-reg-p15 py-5">
            Hortense est à la recherche d'expériences à vous proposer près de
            cet hébergement
          </p>
          <!-- </div>
          </slither-slider> -->
        </template>
        <a 
          v-if="carnetAdress" 
          :href="'/' + carnetAdress.slug" 
          class="hortense-btn-primary"
          :class="isPhone ? 'mx-5' : ''"
          target="_blank"
        >
          DÉCOUVREZ NOTRE CARNET D'ADRESSES
        </a>
      </div>
    </div>
    <div v-if="showModal" class="modal-backdrop" @click.self="closeModal">
      <div class="modal-content">
        <div class="cross" @click.stop="closeModal">
          <img src="../images/Croix fermer.svg" alt="fermer" />
        </div>
        <h4>{{ selectedExperience.name }}</h4>
        <h2>{{ selectedExperience.catch_phrase }}</h2>
        <p >{{ selectedExperience.description }}</p>
        <h2 >Où ?</h2>
        <p class="address-clickable" @click="showExperienceOnMap">{{ selectedExperience.address }}</p>
      </div>
    </div>

  </div>
</template>

<script>
import Cardexplodging from "components/cards/Cardexplodging.vue";
import Maplodgingshow from '../pages/lodgings/Maplodgingshow.vue';

export default {
  name: "experience-lodging-show",
  components: { Cardexplodging, Maplodgingshow },
  props: {
    experiences: Array,
    user: Object,
    carnetAdress: Object,
  },
  data() {
    return {
      SelectedOption: "culturelles",
      categories: [
        "culturelles",
        "au naturel",
        "au bord de l'eau",
        "sportives",
        "immersives",
        "culinaires",
        "diy",
        "oenologiques"
      ],
      experiencesList: this.experiences,
      showModal: false,
      selectedExperience: null,
    };
  },
  methods: {
    openModal(experience) {
      this.selectedExperience = experience;
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
      this.selectedExperience = null;
    },
    isUserConnected() {
      return this.user ? this.user : {};
    },
    openModal(experience) {
      console.log("Opening modal for experience:", experience);
      this.selectedExperience = experience;
      this.showModal = true;
    },
    showExperienceOnMap() {
      this.$emit('showExperienceOnMap', this.selectedExperience);
      this.closeModal();
    },
  },
  computed: {
    experiencesFiltered() {
      console.log("Filtering experiences for category:", this.SelectedOption);
      return this.experiencesList.filter(
        el => el.category_name === this.SelectedOption && el.photo_key
      );
    }
  },
};
</script>
<style lang="scss">
#lodging-show-phone {
  margin-top: 1rem;
  width: 100%;

  h1 {
    text-decoration: none;
    color: black;
    p {
      opacity: 0.4;
      text-transform: uppercase;
      width: max-content;
    }
    &:hover {
      p {
        opacity: 1;
      }
    }
    &.active {
      margin-bottom: 2rem;
      border-bottom: 3px solid #3b6152;
      width: fit-content;

      p {
        opacity: 1;
        font-family: $Raleway;
        font-weight: 700;
        font-size: 16px;
        margin-bottom: 0.3rem;
      }
    }
  }
  #experiences-lodging {
    .info-exp {
      padding-left: 0rem;

        & > div {
          padding: .75rem 0;
        }
      }
    }
  }
  .show-cart-btn {
    text-decoration: underline;
    padding: 10px 0px;
    font-size: 80%;
  }

  .modal-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5) !important;
    display: flex;
    justify-content: center;
    align-items: center;
    opacity : 1 !important
  }

  .modal-backdrop .modal-content {
    background: white;
    padding: 20px;
    border-radius: 5px;
    width: 95%;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }


  .modal-open {
    position: fixed;
    overflow: hidden;
    width: 100%;
  }

  .cross {
    position: absolute;
    top: 8px;
    right: 8px;
    cursor: pointer;
    z-index: 10; /* Ensure it's above other elements */
    img {
      width: 15px;
      height: 15px;
    }
  }
.modal-backdrop .modal-content h2 {
  font-family: Raleway;
  font-weight: 700;
  font-size: 16px;
  line-height: 23.2px;
  letter-spacing: 0%;
  vertical-align: middle;
  text-transform: uppercase;

}
.modal-backdrop .modal-content h4 {
  font-family: Merriweather;
font-weight: 300;
font-style: italic;
font-size: 15px;
line-height: 18px;
letter-spacing: 0%;
vertical-align: middle;
}
.modal-backdrop .modal-content p {
  font-family: Raleway;
  font-weight: 400;
  font-size: 14px;
  line-height: 22.5px;
  letter-spacing: 0%;
  vertical-align: middle;

}

.address-clickable {
  cursor: pointer;
  
  &:hover {
    text-decoration: underline;
  }
}
</style>